// Mock data for Biomedical Sentre Healthcare Solutions

export const companyInfo = {
  name: "Sentre Biomedical Healthcare Private Limited",
  shortName: "Biomedical Sentre",
  tagline: "Complete Healthcare Infrastructure Planning & Compliance Solutions",
  description: "Leading healthcare consultancy providing comprehensive planning, compliance, and infrastructure solutions for hospitals, clinics, and diagnostic centers across India.",
  email: "info@biomedicalsentre.com",
  phone: "+91 9236539380",
  whatsapp: "+919236539380",
  address: "1st Floor, Hafed Complex, Nearest Metro station - Netaji Subhas Palace, near Wazirpur Depot, Block A, Ashok Vihar, New Delhi, Delhi 110035"
};

export const services = [
  {
    id: 1,
    title: "Healthcare Architectural Planning",
    icon: "building",
    description: "Comprehensive hospital layout planning according to healthcare standards and NABH compliance.",
    features: [
      "Hospital layout planning according to healthcare standards",
      "NABH compliant hospital infrastructure planning",
      "ICU, OT, Ward, and OPD layout planning",
      "Workflow optimization for hospitals"
    ],
    image: "https://images.unsplash.com/photo-1769147555720-71fc71bfc216"
  },
  {
    id: 2,
    title: "Healthcare Equipment Planning",
    icon: "activity",
    description: "Expert planning and selection of medical equipment with complete budgeting guidance.",
    features: [
      "Planning and selection of medical equipment",
      "Department-wise equipment planning",
      "Equipment budgeting and procurement guidance",
      "Biomedical infrastructure planning"
    ],
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514"
  },
  {
    id: 3,
    title: "Healthcare Legal Compliance",
    icon: "fileText",
    description: "Complete legal compliance support for hospital registration and regulatory approvals.",
    features: [
      "Hospital registration support",
      "NABH documentation and preparation",
      "Biomedical waste compliance",
      "Fire safety and clinical establishment compliance",
      "Licensing and regulatory approvals"
    ],
    image: "https://images.pexels.com/photos/3845129/pexels-photo-3845129.jpeg"
  },
  {
    id: 4,
    title: "Environmental Compliance",
    icon: "leaf",
    description: "Environmental compliance consulting for pollution control and waste management.",
    features: [
      "Pollution control board approvals",
      "Biomedical waste management compliance",
      "Environmental impact guidance for healthcare facilities"
    ],
    image: "https://images.pexels.com/photos/7089021/pexels-photo-7089021.jpeg"
  },
  {
    id: 5,
    title: "Medical Equipment Services",
    icon: "wrench",
    description: "Comprehensive medical equipment services including installation, maintenance, and calibration.",
    features: [
      "Installation and commissioning of medical equipment",
      "Preventive maintenance of healthcare equipment",
      "Biomedical equipment management support",
      "Equipment calibration and performance checks"
    ],
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514"
  }
];

export const projects = [
  {
    id: 1,
    title: "Tathastu Hospital & Research Center - Lucknow",
    category: "Hospital Planning",
    description: "Complete 300-bed multi-specialty hospital planning with NABH compliance",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/b14gmhx3_unnamed.webp",
    details: "Comprehensive planning including ICU, OT, and OPD layouts"
  },
  {
    id: 2,
    title: "Krishna Diagnostic (Krishna Hospital) - Lucknow",
    category: "Equipment Planning",
    description: "Full diagnostic center equipment planning and procurement",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/o3w933j9_krishna%20hospital-lucknow.png",
    details: "Department-wise equipment selection and budgeting"
  },
  {
    id: 3,
    title: "Dayaram Verma Multispeciality Hospital & Trauma Center - Ambedkar nagar",
    category: "Compliance",
    description: "Complete legal compliance and registration for specialty clinic",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/1hf1sb9o_DJI_0261.jpg",
    details: "All regulatory approvals and licensing completed"
  },
  {
    id: 5,
    title: "V Bros Hospitals - Saharanpur",
    category: "Planning & Compliance",
    description: "Complete project planning and legal compliance",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/xrlpopj1_WhatsApp%20Image%202026-04-07%20at%207.56.43%20PM.jpeg",
    details: "Full service hospital planning with regulatory approvals"
  },
  {
    id: 6,
    title: "Dayaram Verma Multispeciality Hospital & Trauma Center - Ambedkar nagar",
    category: "NABH Compliance",
    description: "Complete blood bank restructuring according to NABH norms",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/3iaha0hk_dr%20verma%20hospital.jpg",
    details: "Blood bank facility upgraded to meet NABH accreditation standards"
  },
  {
    id: 7,
    title: "K.K Hospital - Lucknow",
    category: "Medical Equipment Services",
    description: "Medical Equipment Services",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/d1eozcfo_k.k%20hospital.webp",
    details: "Complete medical equipment installation and maintenance services"
  },
  {
    id: 8,
    title: "Mercy Hospital - Kolkata",
    category: "Medical Equipment Services",
    description: "Medical Equipment Services",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/c0ixxamg_mercy%20hospital-kolkata-equipment%20services.png",
    details: "Comprehensive medical equipment services and maintenance"
  },
  {
    id: 9,
    title: "St. Mary Polyclinic - Lucknow",
    category: "Compliance",
    description: "NABH, NABL, QCI, CGHS accreditation and equipment maintenance",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/50rj0u5h_st%20mary%20polyclinic%20-lucknow-nabh%2Cnabl%2Cqci%2Ccghs%2Cequiment%20maintenace.png",
    details: "Complete compliance services including NABH, NABL, QCI, CGHS certifications and equipment maintenance"
  },
  {
    id: 10,
    title: "CNS Hospital - Lucknow",
    category: "Compliance",
    description: "NABH, NABL, QCI, CGHS accreditation services",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/9aqs1ye5_cns%20hospital-lucknow-nabh%2Cnabl%2Cqci%2Ccghs%2Cqci.png",
    details: "Complete compliance services including NABH, NABL, QCI, and CGHS certifications"
  },
  {
    id: 11,
    title: "KMC Digital Hospital - Maharajganj",
    category: "Compliance",
    description: "NABH, NABL, QCI, CGHS, ECHS accreditation services",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/863mxjhg_kmc%20digital%20hospital-maharajganj-nabh%2Cnabl%2Cqci%2Cechs%2Ccghs.png",
    details: "Complete compliance services including NABH, NABL, QCI, CGHS, and ECHS certifications"
  },
  {
    id: 12,
    title: "CNS Hospital - Satrikh Barabanki",
    category: "Planning & Compliance",
    description: "NABL, QCI accreditation and OT planning",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/l083elbh_cns%20hospital-satrikh%20barabanki%2C%20nabl%2Cqci%2Cot%20plannig.png",
    details: "Complete NABL, QCI accreditation services and operation theatre planning"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Shri.Suresh Kumar Verma",
    role: "Chairman, Dayaram Verma Multispeciality Hospital & Trauma Center",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/kmg7m13t_WhatsApp%20Image%202026-01-19%20at%2011.36.12%20PM.jpeg",
    content: "Biomedical Sentre helped us achieve QCI accreditation seamlessly. Their expertise in hospital planning and compliance is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Sunita Singh",
    role: "Director, K.K Hospital",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/zm4lujba_sunita%20singh.png",
    content: "Excellent support in equipment planning and procurement. They saved us both time and money with their expert guidance.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Ankur Awasthi",
    role: "Director, Tathastu Hospital & Research Center",
    image: "https://customer-assets.emergentagent.com/job_clinical-consultancy/artifacts/evjdwduv_WhatsApp%20Image%202026-04-14%20at%209.34.26%20PM.jpeg",
    content: "Professional team with deep knowledge of healthcare regulations. They handled all our licensing and compliance requirements efficiently.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Essential Requirements for NABH Accreditation in 2024",
    excerpt: "A comprehensive guide to understanding and preparing for NABH accreditation for your healthcare facility.",
    category: "Compliance",
    date: "2024-01-15",
    image: "https://images.unsplash.com/photo-1769147555720-71fc71bfc216",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "Hospital Layout Planning: Best Practices",
    excerpt: "Learn the key principles of effective hospital layout planning that optimize workflow and patient care.",
    category: "Planning",
    date: "2024-01-10",
    image: "https://images.pexels.com/photos/7089021/pexels-photo-7089021.jpeg",
    readTime: "7 min read"
  },
  {
    id: 3,
    title: "Biomedical Waste Management Compliance Guide",
    excerpt: "Everything you need to know about biomedical waste management regulations and compliance requirements.",
    category: "Environmental",
    date: "2024-01-05",
    image: "https://images.pexels.com/photos/3845129/pexels-photo-3845129.jpeg",
    readTime: "6 min read"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Team",
    description: "Experienced healthcare consultants with deep industry knowledge",
    icon: "users"
  },
  {
    id: 2,
    title: "Comprehensive Solutions",
    description: "End-to-end planning, compliance, and implementation support",
    icon: "checkCircle"
  },
  {
    id: 3,
    title: "Proven Track Record",
    description: "Successfully delivered 100+ healthcare projects across India",
    icon: "award"
  },
  {
    id: 4,
    title: "Regulatory Expertise",
    description: "Up-to-date knowledge of all healthcare regulations and standards",
    icon: "shield"
  }
];
